import styled from 'styled-components'

export const Line = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 1.2rem 0.5rem 1.2rem;
  flex-wrap: wrap;

  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background: ${({ theme }) => theme.colors.border};
    width: 100%;
    margin-top: 1rem;
  }

  svg {
    stroke: ${({ theme }) => theme.colors.text.primary};
  }
`

export const Button = styled.button`
  color: ${({ theme }) => theme.colors.hover};
  border: none;
  background: none;
  cursor: pointer;
  display: inline-flex;
  padding: 1rem;
  justify-self: end;
  margin-top: -1rem;
`
